/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDealerLocatorViewProps } from './dealer-locator';

export default (props: IDealerLocatorViewProps) => {
    const css = `#storepoint-tag-dropdown{display:none!important;}`;

    return (
        <React.Fragment>
            <div id="storepoint-container"
                 data-tags={`${props.config.dataTags === undefined ? '' : props.config.dataTags}`}
                 className={`${props.config.cusCSSClasses === undefined ? '' : props.config.cusCSSClasses}`}
                 data-map-id={props.config.storeID}></div>
            {
                typeof window !== 'undefined' ?
                    (function(){
                        const a = document.createElement("script");
                        a.type="text/javascript";
                        a.async=!0;
                        a.src=`https://cdn.storepoint.co/api/v1/js/${ props.config.storeID }.js`;
                        const b = document.getElementsByTagName("script")[0];
                        b.parentNode?.insertBefore(a,b);}())
                    : ''
            }
            {props.config.dataTags === undefined ? '' : <style>{css}</style>}
        </React.Fragment>
    );
};